var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVisualizationSelectionForecastChanges = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.2 13.44h3.84v7.68H19.2z",
  fill: "#81848F"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.4 9.6h3.84v2.88H14.4z",
  fill: "#81848F"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.64 2.88h3.84v5.76H8.64z",
  fill: "#81848F"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M2.88 2.88h3.84v18.24H2.88z",
  fill: "#81848F"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  y: 23.04,
  width: 24,
  height: 0.96,
  fill: "#81848F"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  y: 24,
  width: 24,
  height: 0.960001,
  transform: "rotate(-90 0 24)",
  fill: "#81848F"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 8.64,
  height: 0.96,
  transform: "matrix(-1 0 0 1 23.04 12.48)",
  fill: "#C0C1C7"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 9.6,
  height: 0.96,
  transform: "matrix(-1 0 0 1 12.48 2.88)",
  fill: "#C0C1C7"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 9.6,
  height: 0.96,
  transform: "matrix(-1 0 0 1 18.24 8.64001)",
  fill: "#C0C1C7"
})));
export default SvgVisualizationSelectionForecastChanges;